import { useState } from "react";
import { FileDown, Loader2 } from "lucide-react";
import { useToast } from "../hooks/use-toast";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function PreviewDownloadButton({ variant = "light" }) {
  const { toast } = useToast();
  const [loading, setLoading] = useState(false);

  const download = async () => {
    if (loading) return;
    setLoading(true);
    toast({
      title: "Building your preview…",
      description: "We're capturing each page — this can take up to a minute.",
    });
    try {
      const res = await fetch(`${API}/preview-pdf`);
      if (!res.ok) throw new Error(`Server responded ${res.status}`);
      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      const stamp = new Date().toISOString().slice(0, 10).replace(/-/g, "");
      a.download = `market-street-ventures-preview-${stamp}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
      toast({
        title: "Preview ready",
        description: "Your PDF has been downloaded. Share it with anyone!",
      });
    } catch (e) {
      toast({
        title: "Couldn't generate preview",
        description: "Please try again in a moment.",
      });
    } finally {
      setLoading(false);
    }
  };

  const base =
    "inline-flex items-center gap-2 font-heading uppercase tracking-[0.14em] text-xs px-5 py-3 transition-all duration-300 disabled:opacity-70 disabled:cursor-not-allowed";
  const styles =
    variant === "dark"
      ? "text-white bg-[#1b75bc] hover:bg-[#155e97]"
      : "text-white border border-white/30 hover:bg-white/10";

  return (
    <button onClick={download} disabled={loading} className={`${base} ${styles}`}>
      {loading ? (
        <Loader2 size={15} className="animate-spin" />
      ) : (
        <FileDown size={15} />
      )}
      {loading ? "Generating PDF…" : "Download Site Preview (PDF)"}
    </button>
  );
}
